import { useAppLatyoutContext } from "../../layouts/appLayout"
import { useMediaQuery } from "../helpers/useMediaQuery";
import { useTranslation } from "react-i18next";

export default function Loading({showLoading}){
    const { t } = useTranslation();

    const appLatyoutContext = useAppLatyoutContext();

    const isMobile = useMediaQuery('(max-width: 768px)');

    return(
        showLoading && <div className="fixed w-full h-full top-0 left-0 bg-black/50 select-none z-[100]">
            <div className={`absolute top-0 left-0 h-full flex flex-wrap items-center justify-center content-center ${!isMobile ?  appLatyoutContext?.navState ? '!w-[calc(100vw-229px)] ltr:ms-[229px]' : '!w-[calc(100vw-111px)]' : '!w-[100vw]'}`}>
                <div className="dot-flashing"></div>
                <div className="font-[600] text-white text-[24px] w-full text-center pt-[8px] select-none">{t('processingRequest')}</div>
            </div>
        </div>
    )

}

